var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row l-m-b-16" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c("h2", { staticClass: "l-header-2" }, [
          _vm._v("IFRAME for your website")
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("span", { staticClass: "section-disclaimer" }, [
          _vm._v(
            "\n        Click and copy the script to the clipboard. Paste it into your website in the position you want. The width of the iframe is dependant on the parent element or wrapper. The iframe can be pasted into a <div> element which would dictate the position of your quote form.\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3 mt-3 pl-3 pr-3" }, [
          _c("div", { staticClass: "select-wrap h-auto" }, [
            _c(
              "textarea",
              {
                ref: "script",
                staticClass: "select-wrap-textarea form-control",
                attrs: { rows: "8" },
                on: { click: _vm.doCopy }
              },
              [
                _vm._v(
                  '<iframe width="100%" height="460px" src="' +
                    _vm._s(_vm.widgetUrl) +
                    '" frameborder="0" style="border: 0; order: 2;border-radius: 5px;" scrolling="no" marginheight="0" marginwidth="0" ></iframe>                '
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-3 pl-3 pr-3 d-flex justify-content-end" },
          [
            _c(
              "div",
              {
                staticClass: "assistance",
                on: {
                  click: function($event) {
                    _vm.$emit("setStepCustom")
                  }
                }
              },
              [_vm._v("\n          Switch to custom form?\n        ")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-3 pl-3 pr-3 d-flex justify-content-end" },
          [
            _c(
              "div",
              {
                staticClass: "assistance",
                on: {
                  click: function($event) {
                    _vm.$emit("setStepEditing")
                  }
                }
              },
              [_vm._v("\n          Switch to simple button?\n        ")]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("h2", { staticClass: "l-header-2" }, [_vm._v("FORM INFO")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "section-disclaimer" }, [
        _vm._v(
          "\n        All you need for the form to work is in the iframe. You will copy the iframe into your code and have a working quote within minutes.\n        In the image below you can see an example how the form looks when it’s placed over a page with a background image.        "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3 mt-3 pl-3 pr-3" }, [
        _c("img", {
          attrs: { src: require("../../assets/img/form-widget-min.png") }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bb1e553", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bb1e553","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesWebQuoteIframe.vue
// module id = null
// module chunks = 